import useTripStore from "@/stores/tripBuilder/useTrip";
import useBudgetStore from "@/stores/tripBuilder/useBudgetStore";
import { ItineraryItem } from "@/types/trip";
import { BookingProgressProps, BookingCategories } from "@/types/booking";

const COLORS = {
  accommodation: "#FF6B6B", // Vibrant coral red
  transport: "#4ECDC4", // Bright turquoise
  activities: "#FFD93D", // Sunny yellow
};

export const useBookingProgress = ({
  locationId,
}: BookingProgressProps): BookingCategories[] => {
  const tripData = useTripStore((state) => state.tripData);
  const location = tripData?.locations.find(
    (location) => location.id === locationId
  );
  const budgetBreakdown = useBudgetStore((state) => state.budgetBreakdown);

  const locationTransport = tripData?.transport?.find(
    (transport) => transport.toLocationId === locationId
  );

  const accommodationMain = location?.accommodation?.main;

  const viatorActivities = location?.itinerary_items.reduce((acc, day) => {
    return acc.concat(day.items.filter((item) => item.type === "viator"));
  }, [] as ItineraryItem[]);

  const categories: BookingCategories[] = [
    {
      name: "Transport",
      config: {
        key: "transport",
        icon: "fa-plane",
        label: "Transport",
        color: COLORS.transport,
      },
      completed: locationTransport?.bookingStatus === "booked",
      isPending: locationTransport ? true : false,
      items: budgetBreakdown.transport,
    },
    {
      name: "Accommodation",
      config: {
        key: "accommodation",
        icon: "fa-bed",
        label: "Accommodation",
        color: COLORS.accommodation,
      },
      completed: accommodationMain?.bookingStatus === "booked",
      isPending:
        accommodationMain?.bookingStatus === "pending" ||
        (accommodationMain !== null &&
          accommodationMain?.bookingStatus !== "booked"),
      items: budgetBreakdown.accommodation,
    },
    {
      name: "Activities",
      config: {
        key: "activities",
        icon: "fa-ticket",
        label: "Activities",
        color: COLORS.activities,
      },
      completed:
        viatorActivities?.every(
          (activity) => activity.bookingStatus === "booked"
        ) ?? false,
      isPending:
        viatorActivities?.some(
          (activity) => activity.bookingStatus === "pending"
        ) ?? false,
      items: budgetBreakdown.activities,
    },
  ];

  return categories;
};
